<form>
	<mat-form-field>
		<mat-label>Nazwa grupy oferty</mat-label>
		<input
			matInput
			name="name"
			[(ngModel)]="data.name"
			[disabled]="!editable"
			placeholder="Przykładowo: Chorwacja 2022, Objazdówki Bałkany 2022"
		/>
	</mat-form-field>
</form>
<ng-select
	id="products"
	name="products"
	[(ngModel)]="data.displayedProducts"
	multiple="true"
	[closeOnSelect]="false"
	placeholder="Produkty"
	(change)="updateLocations()"
	[disabled]="!editable"
>
	<ng-option *ngFor="let item of products" [value]="item.id"
		>{{ item.name }}

		<ng-container *ngFor="let loc of item.location">
			<small *ngIf="loc.parentLocation">{{ '(' + loc.name + ', ' + loc.parentLocation.name + ')' }}</small>
			<small *ngIf="!loc.parentLocation">{{ '(' + loc.name + ')' }}</small>
		</ng-container></ng-option
	>
</ng-select>
<ng-select
	id="locations"
	name="locations"
	[(ngModel)]="showLocations"
	multiple="true"
	[closeOnSelect]="false"
	placeholder="Lokalizacje"
	disabled="true"
>
	<ng-option *ngFor="let item of locations" [value]="item.id">{{ item.name }}</ng-option>
</ng-select>
<div class="d-flex flex-row">
	<div class="col">
		<mat-form-field appearance="fill">
			<mat-label>Od:</mat-label>
			<input matInput [ngModel]="dateRange.lower" disabled="true" />
		</mat-form-field>
	</div>
	<div class="col ms-4">
		<mat-form-field appearance="fill">
			<mat-label>Do:</mat-label>
			<input matInput [ngModel]="dateRange.upper" disabled="true" />
		</mat-form-field>
	</div>
</div>
